<template>
    <div>
        <div class="interview-header">
            Clarifying your
            <strong>eligibility for tax treaties</strong>
            <div class="interview-subheader">
                You may be eligible for one or more tax treaties between the
                U.S. and
                {{ context.country }}.
            </div>
        </div>

        <validation-observer ref="validator">
            <fly-col
                :schema="sections[0].schema"
                :data="sections[0].data"
            ></fly-col>
        </validation-observer>

        <modal v-model="unsupported">
            <template v-slot:title> We're sorry </template>

            <template v-slot:body>
                Thriftax does not support tax filing for US citizens.
                <br />
                <br />
                Answered yes by mistake? Click "Close" and change your answer.
            </template>
        </modal>
    </div>
</template>

<script>
import baseInterviewMixin from '@/views/interview/mixins';

export default {
    mixins: [baseInterviewMixin],
    data() {
        return {
            pageName: 'clarify_treaties',

            unsupported: false,
        };
    },
    methods: {
        continueSubmit() {
            if (
                'taxed_as_resident' in this.sections[0].data &&
                this.boolEq(true, this.sections[0].data.taxed_as_resident)
            ) {
                this.unsupported = true;
                return false;
            }
            return true;
        },
    },
    mounted() {
        if ('taxed_as_resident' in this.sections[0].data) {
            this.$watch('sections.0.data.taxed_as_resident', (val) => {
                if (this.boolEq(true, val)) {
                    this.unsupported = true;
                }
            });
        }
    },
};
</script>
